__turbopack_context__.v({
  "article": "RiWvMG_article",
  "blog-article": "RiWvMG_blog-article",
  "blog-nav": "RiWvMG_blog-nav",
  "breadcrumbs": "RiWvMG_breadcrumbs",
  "hero": "RiWvMG_hero",
  "more-articles": "RiWvMG_more-articles",
});
